// Eligibility for the supervisor "Enviar parcial" (tarja) action.
//
// Two paths share the same button, dialog and batch polling; they differ in the order shape that
// qualifies and the endpoint hit on confirm:
//  - classic (no picking tasks): parked with in_review, in picking.
//  - picking tasks: parked with in_review, OR flagged requires_partial_fulfillment (the Natura
//    mandatory tarja), in processing or picking.
// Both additionally require the Pundit permission and the per-store config flag.

export const PARTIAL_FULFILL_MODE_D2C = 'd2c'
export const PARTIAL_FULFILL_MODE_B2B = 'b2b'

// D2C fulfils only from picking; B2B can still be in processing when it stalls.
export const D2C_PARTIAL_FULFILLMENT_STATUSES = ['picking']
export const B2B_PARTIAL_FULFILLMENT_STATUSES = ['processing', 'picking']

/**
 * Decide which partial-fulfillment path (if any) an order qualifies for.
 *
 * @param {object} order - a WMS processing order.
 * @param {{hasPermission?: boolean, storeConfigEnabled?: boolean}} context
 *   permission + per-store config, resolved by the caller.
 * @returns {'d2c'|'b2b'|null}
 */
export const getPartialFulfillMode = (order, { hasPermission, storeConfigEnabled } = {}) => {
    if (!order || !hasPermission || !storeConfigEnabled || !order.store?.id) return null

    const pickingOrder = order.picking_order || {}

    if (
        order.uses_picking_tasks &&
        (pickingOrder.in_review || pickingOrder.requires_partial_fulfillment) &&
        B2B_PARTIAL_FULFILLMENT_STATUSES.includes(order.status)
    ) {
        return PARTIAL_FULFILL_MODE_B2B
    }

    if (
        !order.uses_picking_tasks &&
        pickingOrder.in_review &&
        D2C_PARTIAL_FULFILLMENT_STATUSES.includes(order.status)
    ) {
        return PARTIAL_FULFILL_MODE_D2C
    }

    return null
}
